import React from 'react';
import BaseCompetency from '../Application/BaseCompetency';
import { ST_COMPETENCY_ITEMS } from './stConstants';

const STCompetency = ({ targetUserId, onClose }) => {
    return (
        <BaseCompetency
            role="ST"
            title="ST CLINICAL COMPETENCY ASSESSMENT"
            items={ST_COMPETENCY_ITEMS}
            totalPages={6}
            apiEndpoint="/competencies"
            fetchEndpoint="/competencies"
            targetUserId={targetUserId}
            onClose={onClose}
        />
    );
};

export default STCompetency;
